import {
    SET_AVAILABLE_FC,
    SET_MY_FC,
    SET_PAST_FC,
    SET_CART_FC,
    ADD_DETAILS_FC
} from './types'

export default function(state={}, action) {
    switch (action.type) {
        /*case ALL_INVENTORY: {
            const {available, my} = action.payload.reduce(({available,my},stone) => {
                if (stone.customerId==null) return {available: available.concat([stone]), my};
                else return {available, my: my.concat([stone])};
            }, {available: [], my: []});
            return {...state, available, my}
        }*/
        case SET_AVAILABLE_FC: {
            return {...state, available: action.payload}
        }
        case SET_MY_FC: {
            return {...state, my: action.payload}
        }
        case SET_PAST_FC: {
            return {...state, past: action.payload}
        }
        case SET_CART_FC: {
            return {...state, cart: action.payload}
        }
        case ADD_DETAILS_FC: {
            if (!action.payload || !action.payload.parcelName) return state;
            return {...state, details: {...state.details, [action.payload.parcelName]: action.payload}}
        }
        default: {
            return state;
        }
    }
}